import { CustomModal } from 'components/modals/ModalBox'
import React from 'react'

const ReadMore = ({ show, close, title = '', description = '' }) => {
    return (
        <CustomModal
            className={"add_model"}
            show={show}
            handleClose={close}
        >
            <div className="p-3">
                <h3
                    className="mb-3  fw-bold border-bottom pb-2"
                    style={{
                        fontSize: '20px',
                        letterSpacing: '0.5px',
                        borderColor: '#dee2e6',
                    }}
                >
                    {title}
                </h3>
                <p
                    className="text-secondary"
                    style={{
                        fontSize: '16px',
                        lineHeight: '1.7',
                        wordBreak: 'break-word',
                    }}
                >
                    {description}
                </p>
            </div>
        </CustomModal>
    );
}

export default ReadMore